import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { TID } from "@/lib/testIds";

const links = [
  { to: "/#lifestyle", label: "The Set" },
  { to: "/collection/launch", label: "Launch" },
  { to: "/collection/club", label: "Club" },
  { to: "/collection/scenic-dial", label: "Scenic Dial" },
  { to: "/collection/scenic-petite", label: "Petite" },
  { to: "/allocation", label: "Allocation" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (e, to) => {
    if (!to.startsWith("/#")) return;
    const hash = to.slice(2);
    if (pathname === "/") {
      e.preventDefault();
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      e.preventDefault();
      navigate(`/#${hash}`);
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    }
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#14201a]/85 backdrop-blur-md border-b border-[rgba(197,160,89,0.18)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-16 sm:h-20">
        <Link
          to="/"
          data-testid={TID.navBrand}
          className="font-serif-display text-2xl sm:text-3xl text-[#F5F2EB] tracking-[0.18em]"
        >
          CLEMENT
        </Link>
        <nav className="hidden md:flex items-center gap-10" aria-label="Primary">
          {links.map((l) => {
            const isActive = !l.to.startsWith("/#") && pathname === l.to;
            return (
              <Link
                key={l.to}
                to={l.to}
                onClick={(e) => handleClick(e, l.to)}
                aria-current={isActive ? "page" : undefined}
                className={`text-[11px] uppercase tracking-[0.28em] transition-colors duration-300 ${
                  isActive
                    ? "text-[#C5A059]"
                    : "text-[#A8A9AD] hover:text-[#C5A059]"
                }`}
              >
                {l.label}
              </Link>
            );
          })}
        </nav>
        <Link
          to="/#waitlist"
          onClick={(e) => handleClick(e, "/#waitlist")}
          data-testid={TID.navWaitlistCta}
          className="text-[11px] uppercase tracking-[0.28em] border border-[#C5A059] text-[#C5A059] px-4 sm:px-5 py-2.5 hover:bg-[#C5A059] hover:text-[#0C0F0A] transition-colors duration-300"
        >
          Request Access
        </Link>
      </div>
    </header>
  );
}
